import { useEffect, useState } from "react";

const OpCodeDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = "OpCode Verification",
    message = "Enter the 6-digit OpCode to continue with this sensitive action.",
    confirmText = "Verify",
    cancelText = "Cancel",
    type = "warning", // 'info' | 'warning' | 'danger'
}) => {
    const [opCode, setOpCode] = useState("");

    useEffect(() => {
        if (!isOpen) setOpCode("");
    }, [isOpen]);

    useEffect(() => {
        const handleEsc = (e) => e.key === "Escape" && onClose();
        if (isOpen) document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const colorMap = {
        info: "from-blue-500 to-indigo-500",
        warning: "from-amber-400 to-orange-500",
        danger: "from-rose-500 to-red-600",
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[2px] p-4">
            <div className="bg-white rounded-2xl w-full max-w-sm sm:max-w-md shadow-xl animate-fadeIn border border-gray-200">
                {/* Header */}
                <div
                    className={`rounded-t-2xl bg-gradient-to-r ${colorMap[type]} text-white px-5 py-4`}
                >
                    <h3 className="text-lg font-semibold">{title}</h3>
                </div>

                {/* Body */}
                <div className="p-5 space-y-4">
                    <p className="text-gray-700 text-sm sm:text-base text-center">
                        {message}
                    </p>

                    <input
                        type="text"
                        inputMode="numeric"
                        maxLength={6}
                        value={opCode}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setOpCode(value);
                        }}
                        placeholder="Enter 6-digit OpCode"
                        className="w-full text-center tracking-widest text-lg font-semibold border rounded-lg px-3 py-2 focus:ring-2 focus:ring-orange-400 outline-none"
                    />

                    <p className="text-xs text-gray-500 text-center">
                        Do not share this OpCode with anyone.
                    </p>
                </div>

                {/* Footer */}
                <div className="flex justify-end space-x-3 px-5 py-4 bg-gray-50 rounded-b-2xl">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded-lg text-gray-700 bg-gray-200 hover:bg-gray-300 transition text-sm sm:text-base"
                    >
                        {cancelText}
                    </button>

                    <button
                        disabled={opCode.length !== 6}
                        onClick={() => {
                            onConfirm(opCode);
                            onClose();
                        }}
                        className={`px-4 py-2 rounded-lg text-white bg-gradient-to-r ${colorMap[type]} hover:opacity-90 transition text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OpCodeDialog;